import { API } from "../../../utils";

export const getTenantBrandingApi = async () => {
  const res = await API.get("/settings/branding");
  return res.data;
};

export const updateTenantBrandingApi = async (payload) => {
  const res = await API.put("/settings/branding", payload, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};
